export const isIMGElement = (el: HTMLElement): el is HTMLImageElement =>
  el instanceof HTMLImageElement
